import { createAction } from 'redux-act'

export const to = createAction('navigation to', (page, data) => ({
  page,
  data
}))
